import { useMutation, useQuery } from "@tanstack/react-query";
import { postBulkUserInvite } from "../../../api/Terminal/UserAccount";
import { IPostBulkUserInvitePayload } from "../../../api/Terminal/UserAccount/types";
import {
  getUsers,
  IPostUserInviteServicePayload,
  sendInvite,
} from "../../../api/user";
import { ReactQueryKey } from "../../../constants/ReactQueryKeys";
import { QueryParamsInterface } from "../../../types/Shared";

interface IUsersHookProps {
  onSuccess?: (data: any) => void;
  onError?: (err: any) => void;
  params?: QueryParamsInterface;
}

export const useUsers = ({ onSuccess, onError, params }: IUsersHookProps) => {
  return useQuery(
    [ReactQueryKey.GET_USERS, params],
    () => getUsers({ params }),
    {
      onSuccess,
      onError,
      keepPreviousData: true,
      staleTime: 30000,
    }
  );
};

interface IBulkUserInviteHookProps {
  onSuccess?: (data: any) => void;
  onError?: (err: any) => void;
}

export const useBulkUserInvite = ({
  onSuccess,
  onError,
}: IBulkUserInviteHookProps) => {
  return useMutation(
    (data: IPostBulkUserInvitePayload) => postBulkUserInvite({ data }),
    {
      onSuccess,
      onError,
    }
  );
};

export const useUserInvite = ({
  onSuccess,
  onError,
}: IBulkUserInviteHookProps) => {
  return useMutation(
    (data: IPostUserInviteServicePayload) => sendInvite(data),
    {
      onSuccess,
      onError,
    }
  );
};
